import { render, staticRenderFns } from "./CancelOrderModal.vue?vue&type=template&id=5f38a594&"
import script from "./CancelOrderModal.vue?vue&type=script&lang=js&"
export * from "./CancelOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports